export enum AuditAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete'
}

export enum AuditContentType {
  CMS = 'cms',
  EMS = 'ems',
  TRC = 'trc',
  TMS = 'tms'
}

export interface AuditLog {
  timestamp: string;
  object_repr: string;
  content_type: AuditContentType | string;
  action: AuditAction;
  object_id: number;
  actor: string;
  details: AuditLogDetail[];
}

export interface AuditLogDetail {
  field: string;
  changes: string[];
}
